import { useEffect } from 'react';

export function useUserActivity(onActivity) {

  useEffect(() => {
    
    const handleActivity = () => { onActivity(); };

    const events = ['mousemove', 'keydown', 'click', 'scroll'];

    events.forEach(event => window.addEventListener(event, handleActivity));

    return () => { events.forEach(event => window.removeEventListener(event, handleActivity)); };

  }, [onActivity]);

}
